export default "__VITE_ASSET__6c401dfa__"